function getRandomBetween(min, max){
  return min + (Math.random() * (max - min));
}

export function getRandomIntegerBetween(min, max){
  return Math.round(getRandomBetween(min, max));
}

export function getRandomRGBColor(){
  const red = getRandomIntegerBetween(0, 255);
  const green = getRandomIntegerBetween(0, 255);
  const blue = getRandomIntegerBetween(0, 255);
  return `rgb(${red}, ${green}, ${blue})`;
}

export function getRandomVelocityVector(minX = -1, minY = -1, maxX = 1, maxY = 1) {
  return {
    x: getRandomBetween(minX, maxX),
    y: getRandomBetween(minY, maxY)
  }
}

export function createNInstances(numberOfInstances, initInstance){
  return new Array(numberOfInstances)
    .fill(0)
    .map(() => initInstance())
}



// WEBPACK FOOTER //
// ./src/helpers/index.js